document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
        let discountCodes = data.discount_codes || [];
        let discount = discountCodes.map(item => item.code);
        const discountElement = document.querySelector('.detail_copy_text');
        if (discountElement) {
          const discountText = discountElement.textContent.trim();
          if (!discount.includes(discountText)) {
            discount.unshift(discountText);
          }
          const finalDiscount = discount.join(',');
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                discount: finalDiscount
              })
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
    })
  .catch(error => {
    console.error('获取购物车数据时出错:', error);
  });
})

const spec_table_content_arrow_bth = document.getElementById('spec_table_content_arrow_bth');
if(spec_table_content_arrow_bth){
  document.getElementById('spec_table_content_arrow_bth').addEventListener('click', function() {
    var content = document.querySelector('#spec_table_content');
    var showText = document.querySelector('.spec_table_content_showtxt');
    var arrowIcon = document.querySelector('.spec_table_content_arrow_icon');
    if (showText.textContent === "More") {
      content.classList.add('expanded');
      showText.textContent = "Less";
      arrowIcon.classList.remove('tw-rotate-180');
    } else {
      content.classList.remove('expanded');
      showText.textContent = "More";
      arrowIcon.classList.add('tw-rotate-180'); 
    }
  });
}

function applyExtraDiscount() {
  const containers = document.querySelectorAll('.price-stack');
  containers.forEach(container => {
    const originalCents = parseInt(container.dataset.originalPrice);
    const currentCents = parseInt(container.dataset.currentPrice);
    const discountText = container.dataset.discountText;
    if (isNaN(currentCents) || !discountText) return;

    let finalCents = null;

    // 金额：$80 OFF 或 80 OFF
    const amountMatch = discountText.match(/\$?(\d+(?:\.\d+)?)\s*OFF/i);
    if (amountMatch) {
      const discountAmount = parseFloat(amountMatch[1]);
      finalCents = currentCents - discountAmount * 100;
    }

    // 百分比：20% OFF
    const percentMatch = discountText.match(/(\d+(?:\.\d+)?)\%\s*OFF/i);
    if (percentMatch) {
      const percent = parseFloat(percentMatch[1]);
      let rawCents = currentCents * (1 - percent / 100);
      // 向上取整，匹配官方折扣计算规则
      finalCents = Math.ceil(rawCents);
    }

    if (finalCents !== null && finalCents >= 0) {
      const finalPrice = (finalCents / 100).toFixed(2);
      const finalSpan = container.querySelector('.price-final');
      const currentSpan = container.querySelector('.price-current');
      const savedCents = originalCents - finalCents;
      const savedAmount = (savedCents / 100).toFixed(2);
      const savedAmountFormatted = `$${savedAmount}`;
      const productCard = container.closest('.product-card');
      if (productCard) {
        const custom_save_badges = productCard.querySelector('.custom_save_badges');
        const templateSpan = productCard.querySelector('.save-template');
        if (custom_save_badges && templateSpan) {
          let templateText = templateSpan.innerHTML;
          const finalText = templateText.replace('{{ saved_amount }}', savedAmountFormatted);
          custom_save_badges.textContent = finalText;
        }
      }
      
      finalSpan.textContent = `$${finalPrice}`;
      currentSpan.style.display = 'none'; // 隐藏第一层折扣价
    }
  });
}

document.addEventListener('DOMContentLoaded', applyExtraDiscount);